import axios from "axios";
import { BASE_URL } from "../../api/BaseConfig";
import { SLIDER_ADD_FAIL, SLIDER_ADD_REQUEST, SLIDER_ADD_SUCCESS, SLIDER_DELETE_FAIL, SLIDER_DELETE_REQUEST, SLIDER_DELETE_SUCCESS, SLIDER_EDIT_FAIL, SLIDER_EDIT_REQUEST, SLIDER_EDIT_SUCCESS, SLIDER_LIST_FAIL, SLIDER_LIST_REQUEST, SLIDER_LIST_SUCCESS, SLIDER_UPDATE_FAIL, SLIDER_UPDATE_REQUEST, SLIDER_UPDATE_SUCCESS } from "../Constants/SliderConstans";

export const SliderAdd = (sliderData) => async (dispatch) => {
  try {
    dispatch({ type: SLIDER_ADD_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    
    const { data } = await axios.post(
      `${BASE_URL}/Slider`,
      JSON.stringify(sliderData),
      config
    );  
    dispatch({ type: SLIDER_ADD_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: SLIDER_ADD_FAIL, payload: error });
  }
};

export const SliderUpdateAction = (slider) => async (dispatch,getstate) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    dispatch({ type: SLIDER_UPDATE_REQUEST });
    const { data } = await axios.put(
      `${BASE_URL}/Slider/${slider.id}`,
      JSON.stringify(slider),
      config
    );
    dispatch({ type: SLIDER_UPDATE_SUCCESS, payload: data });
    dispatch({ type: SLIDER_EDIT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: SLIDER_UPDATE_FAIL, payload: error });
  }
};

export const ListSliders = (pageNo) => async (dispatch) => {
  try {
    dispatch({ type: SLIDER_LIST_REQUEST });
    
    const { data } = await axios.get(`${BASE_URL}/Slider/all/AZ/${pageNo}`);
    dispatch({ 
      type: SLIDER_LIST_SUCCESS, 
      payload: {
        sliders: data.sliders,
        currentPage: data.currentPage,
        totalPages: data.totalPages,
        totalRecords: data.totalRecords,
        recordSize: data.recordSize,
      },
    });
  } catch (error) {
    dispatch({ 
      type: SLIDER_LIST_FAIL, 
      payload: error.response?.data?.message || error.message,
    });
  }
};


export const SliderEditAction = (id) => async (dispatch) => {
  console.log(id)
  try {
    dispatch({ type: SLIDER_EDIT_REQUEST });
    const { data } = await axios.get(`${BASE_URL}/Slider/details/${id}`);
    console.log(data);
    dispatch({ type: SLIDER_EDIT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: SLIDER_EDIT_FAIL, payload: error });
  }
};


export const SliderDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: SLIDER_DELETE_REQUEST });
   await axios.delete(`${BASE_URL}/Slider/${id}`);
    dispatch({
      type: SLIDER_DELETE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: SLIDER_DELETE_FAIL,
      payload: error,
    });
  }
};


